import useApi from 'src/hooks/useApi';
import { PayrollLinkUser } from 'src/types/applicantExperienceApi';
import { ARGYLE_V2_API_URL } from 'src/features/DUP';
import { useMemo } from 'react';
import { SessionApplication, SessionProperty } from 'src/types/api';

const SNAPPT_PHONE_NUMBER = '18444762778';

export const useArgyleUser = (application: SessionApplication, property: SessionProperty) => {
  const user = useMemo(
    () => ({
      firstName: application?.firstName,
      lastName: application?.lastName,
      phone: application?.phone,
      email: application?.email,
      property: {
        name: property?.name,
        address: property?.address,
        city: property?.city,
        state: property?.state,
        zip: property?.zip,
        phone: property?.phone || SNAPPT_PHONE_NUMBER
      }
    }),
    [application, property]
  );

  const { makeRequest: createDetailedUser, data: argyleDetailedUser } = useApi<PayrollLinkUser>({
    body: user,
    url: `${ARGYLE_V2_API_URL}/users`,
    method: 'POST',
    loadsOnMount: false
  });

  return {
    createDetailedUser,
    argyleDetailedUser
  };
};
